<template>
    <div class="w-6 h-6">
        <base-dropdown
            placement="bottom-end"
            class="w-full h-full"
        >
            <button
                slot="trigger"
                slot-scope="{ is_open, toggle }"
                :class="{ 'shadow-outline': is_open }"
                class="btn btn-none w-full h-full"
                type="button"
                @click.prevent="toggle"
            >
                <base-svg
                    name="icon-dots-horizontal"
                    class="h-full w-full"
                />
            </button>

            <div
                slot="menu"
                slot-scope="{ close }"
                class="dropdown-menu w-64"
            >
                <router-link
                    :to="{
                        name: $router.fix('dashboard.*.properties.edit'),
                        params: {
                            property: property.uuid
                        }
                    }"
                    class="dropdown-menu-link"
                >
                    Edit
                </router-link>

                <button
                    v-if="!property.archived_at"
                    type="button"
                    class="dropdown-menu-link"
                    @click.prevent="close(() => show_properties_archive_edit_modal = true)"
                >
                    Archive
                </button>
            </div>
        </base-dropdown>

        <properties-archive-edit-modal
            v-model="show_properties_archive_edit_modal"
            :property="property"
            @success="onSuccess"
        />
    </div>
</template>

<script>
    import PropertiesArchiveEditModal from './edit-dropdown/properties-archive-edit-modal'

    export default {
        components: {
            PropertiesArchiveEditModal
        },
        props: {
            property: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_properties_archive_edit_modal: false
            }
        },
        methods: {
            onSuccess () {
                this.$emit('success')
            }
        }
    }
</script>
